export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11960.c1d19441.jpg";